module.exports = __webpack_public_path__ + "img/sala-xpto.87833207.jpg";